"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  roleCertificationApplication: {
    cargoOwner: 'Cargo Owner',
    forwarder: 'Forwarder',
    transportTeam: 'Transport Team',
    viewLink: 'View Link',
    roleApplication: 'Role Certification Application',
    uploadAttachment: 'Upload Attachment',
    notBeEmpty: 'Can not be empty',
    companyType: "Company Type",
    companyName: "Company Local Full Name",
    companyNameEn: "Company English Full Name",
    usci: "Unified Social Credit Code",
    companyAbbrev: "Company Abbreviation",
    companyAddress: "Company Address",
    country: "Country (Region)",
    province: "Province (City)",
    city: "City",
    businessLicenseScanningCopy: "Business License Scanning Copy",
    importEdoPromise: "Import EDO Promise",
    simisCompanyCode: 'Company Code',
    simisCompanyNameCn: 'Company Name Cn',
    simisCompanyNameEn: 'Company Name En',
    jpBookingForwarderCode: "Agency",
    faxNo: "Fax Number",
    freightDeliveryMethod: 'Freight delivery method',
    emailCheck: "Email",
    faxCheck: "Fax",
    portCode: 'Select Port',
    MobilePhone: 'Mobile Phone',
    contactMobilePhone: 'phone',
    contactPhone: 'Contact Phone',
    taxNo: 'Tax No',
    edoUnitType: 'Declaration Unit Type',
    edoUserName: 'Declarant Name',
    edoUserIdNumber: 'Declarant ID Number',
    edoEmail: 'Email',
    bookingJp: 'Booking from Japan ports',
    bookingNotJp: 'Booking from outside of Japan ports',
    outDgDec: 'Outbound DG Declaration',
    inEdo: 'Forespeak Delivery Order',
    terms: 'Terms and Conditions',
    agreement: 'Read and Agree',
    confirm: 'I agree to the above terms and confirm',
    edit: 'Edit',
    notReject: 'Only the reject status can be edited!',
    notEdit: 'The current account is a sub-account and no application is required!',
    deleteMessage: 'Delete Success',
    businessLicenseScanningCopyNotNull: 'The copy of the business license cannot be empty',
    invalidPhone: 'Phone format error',
    roleDetail: 'Role Authentication Application Details',
    roleCode: "Role",
    port: "Port",
    authStatus: "Authentication Status",
    applyDate: "Application Date",
    approveRemark: "Approval Remark",
    agent: "Agent",
    phone: "Phone",
    fax: "Fax",
    freightSendingMethod: "Freight Sending Method",
    applying: "Applying",
    approving: "Approving",
    approved: "Approved",
    rejected: "Rejected",
    saveSuccessfully: 'Save Successfully',
    agreeTerms: 'Please read and agree to the terms',
    add: 'Apply Permission',
    compangEnMessage: 'Only letters and English symbols can be filled in',
    tips: 'Remark: If you need to modify company information and business license scanning copy, please cancel all approved roles and then edit application for permission.',
    cancel: 'Cancel',
    cancelSuccess: 'Cancel Success',
    errMsg: 'Data request failed. Please try again later',
    confirmContent: 'Cancel or not？'
  },
  roleCertificationApplicationTable: {
    roleCode: 'Role',
    officeAbbrev: 'Office Abbreviation',
    portCode: 'Port',
    jpBookingForwarderCode: 'Agency',
    authStatus: 'Authentication Status',
    applyDate: 'Application Date',
    actions: 'Actions'
  }
};